import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RestService} from '../providers/rest.service';
import {ToastrService} from 'ngx-toastr';
import {KullaniciGrup} from '../model/kullanici-grup';
import {Kullanici} from '../model/kullanici';
import {Yetki} from '../model/yetki';
import {KullaniciGrupYetkiDuzenleRequest} from '../model/kullanici-grup-yetki-duzenle-request';

@Component({
  selector: 'app-kullanici-grup-ekle-duzenle',
  templateUrl: './kullanici-grup-ekle-duzenle.component.html',
  styleUrls: ['./kullanici-grup-ekle-duzenle.component.css']
})
export class KullaniciGrupEkleDuzenleComponent implements OnInit, OnDestroy {

  subscriptions: Subscription[] = [];
  id: string = null;
  kullaniciGrup: KullaniciGrup = null;
  kullanicilar: Kullanici[] = null;
  yetkiler: Yetki[] = null;
  selectAllVal = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private restService: RestService,
              private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      console.log(params);
      this.id = params.id;
      if (this.id !== '0') {
        debugger;
        this.getKullaniciGrup();
        this.getKullanicilar(true);
      } else {
        this.getYetkiler();
        this.kullaniciGrup = new KullaniciGrup();
        this.kullaniciGrup.isim = '';
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getKullaniciGrup() {
    this.restService.getKullaniciGrup(this.id).subscribe(res => {
      if (res) {
        this.kullaniciGrup = res;
        debugger;
        this.getYetkiler();
      }
    });
  }

  save() {
    const subscription2 = res => {
      this.toastrService.show('Kaydedildi', 'Başarılı');
      this.router.navigate(['kullanici-gruplar']);
    };

    const subscription1 = res => {
      const request = new KullaniciGrupYetkiDuzenleRequest();
      request.kullaniciGrupId = this.kullaniciGrup.id;
      request.yetkiIdListe = this.yetkiler.filter(x => x.checked).map(x => x.id);

      this.restService.kullaniciGrupYetkiDuzenle(request).subscribe(subscription2);
    };

    if (this.id === '0') {
      this.restService.kullaniciGrupEkle(this.kullaniciGrup).subscribe(subscription1);
    } else {
      this.restService.kullaniciGrupDuzenle(this.kullaniciGrup).subscribe(subscription1);
    }
  }

  getKullanicilar(event: boolean) {
    if (event) {
      this.restService.grupKullanicilar(this.id).subscribe(res => {
        if (res) {
          this.kullanicilar = res;
        }
      });
    }
  }

  getYetkiler() {
    this.restService.getYetkiler().subscribe(res => {
      if (res) {
        this.yetkiler = res;
        if (this.yetkiler != null && this.kullaniciGrup.kullaniciGrupYetkiler != null) {
          for (const e of this.yetkiler) {
            if (this.kullaniciGrup.kullaniciGrupYetkiler.findIndex(x => x.yetkiId === e.id) !== -1) {
              e.checked = true;
            }
          }
          this.selectAllVal = this.yetkiler.findIndex(x => !x.checked) === -1;
        }
      }
    });
  }

  selectAll() {
    this.yetkiler.forEach(x => x.checked = this.selectAllVal);
  }

  selectAllUpdate() {
    this.selectAllVal = this.yetkiler.findIndex(x => !x.checked) === -1;
  }


}
